export default [
  {
    path: "ff3c63ef97e6fc7b0f43bacf",
    name: "bece25.payments",
    meta: {
      title: "BECE 25 Payment(s)",
      authRequired: true,
    },
    component: () => import("@/views/bece/twf/payment/index.vue"),
  },
  {
    path: "ff45320cbc2ec5c967470710",
    name: "bece25.pin.requests",
    meta: {
      title: "BECE 25 Pin Request(s)",
      authRequired: true,
    },
    component: () => import("@/views/bece/twf/payment/index2.vue"),
  },
  {
    path: "ff77a862e70d3c4af4944655",
    name: "bece25.transactions",
    meta: {
      title: "BECE 25 Transaction",
      authRequired: true,
    },
    component: () => import("@/views/bece/twf/payment/transactions.vue"),
  },
  {
    path: "ff5937c7e766b7fe6e6f6b59",
    name: "bece25.pending.pin.requests",
    meta: {
      title: "BECE 25 Pending Pin Request",
      authRequired: true,
    },
    component: () => import("@/views/bece/twf/payment/transactions2.vue"),
  },
];
